/* eslint key-spacing: 'off', comma-spacing: 'off', brace-style: 'off' */
import current from '@/scripts/current';
import commonTestHelper from '@/scripts/commonTestHelper';
import variableDataAccess from '@/scripts/variableDataAccess';
import VariableSelection from '@/bo/VariableSelection';
import testHelper from '@/scripts/crossTabulation/testHelper';
import store from '@/store';

function setTestUpTo() {
    // return 'years';
    // return 'locations';
    //return 'row';
    // return 'column';
    //return 'control1';
    // return 'control2';
    return null;
}

function toStateYearKey(state, year) {
    return "" + state + "|" + year;
}

function getMissingStateYears() {
    let years = {};
    let states = {};
    let yearStates = {};
    const stateYearCounts = store.state.dataLists.stateYearCounts;
    stateYearCounts.forEach(c => yearStates[toStateYearKey(c.State, c.Year)] = states[c.State] = years[c.Year] = true);
    let missingStateYears = Object.keys(years).map(y =>
        Object.keys(states).map(s => toStateYearKey(s, y)).filter(k => !yearStates[k])
    ).reduce((a, b) => a.concat(b));
    //Missing state years
    //15, 2004
    //66, 2004-2006
    //78, 2011-2015, 2017
}

//Set environment variables
//https://stackoverflow.com/questions/50828904/using-environment-variables-with-vue-js
//https://cli.vuejs.org/guide/mode-and-env.html


export default {
    variableList: null,
    getVariableList: function () {
        if (!testHelper.variableList)
            testHelper.variableList = variableDataAccess.getPairedVariables1(['isRow']);
        return testHelper.variableList;
    },
    setTestValues: function (currentStep, $route) {
        var node = process.env.NODE_ENV;
        if (process.env.NODE_ENV && process.env.NODE_ENV !== 'development')
            return;
        commonTestHelper.setIsInAutomatedTesting($route);
        // Lots of Levels (2006, 2008,   2010): R_AGEG5YR, RC_DRINKDRI, RN_DRNKDRI2, RC_FALL3MN2, RC_FALLINJ2, RC_MENTHLTH, RC_PHYSHLTH, RC_POORHLTH
        // YesNo (2006, 2008, 2010): 'R_AIDSTST', 'R_ALTETH2', 'R_ASTHMA', 'R_ASTHNOW', 'R_BLDSTOOL's
        //


        var stepIndex = current.navigation.stepIndex[currentStep];
        if (window.inAutomatedTesting) {
            return commonTestHelper.setAutomatedTestValues(stepIndex, testHelper.getVariableList());
        }


        //justCompareYears
        //errorDownloading1        
        //longCtlLevelNames
        //noCi
        //noCi2
        //justCompareYears
        var test = 'none';  //rowOnly, missingData2, noDataNotRight
        if ((!test) || test === 'none')
            return;
        else if (test === 'error006')
            setTest(stepIndex, [2018], [1,2,4,5,6], ['R_VETERAN3', 'RC_DROCDY3_', 'R_AGEG5YR'], { confidenceInterval: true });
        else if (test === 'justCompareYears')
            setTest(stepIndex, [2012, 2014], [1], ['year', 'R_RFBLDS2', 'R_RFSEAT3']); //Tested for 3.1
        //Test testVi13, testVi14, testVi10,
        //submit=Run+Report&_program=brfss_p.ct.sas&_service=nccdphp&
        //years=2017&fips_codes=5&row_var=R_AGE65YR&column_var=R_INCOME&control_var1=R_VETERAN3&control_var2=R_AGEG5YR&statistics=weighted_n&additional_statistics=confidence_interval&include_non_response_levels=true&output_format=json
        else if (test === 'smallYearAndLocation')
            setTest(stepIndex, [2012, 2014], [1, 5], ['year', 'location', 'R_RFSEAT3', 'R_RFBLDS2']); //Tested for 3.1
        else if (test === "errorDownloading1")
            setTest(stepIndex, [2015], [2], ['R_AGEG5YR', 'R_USEEQUIP', 'R_DECIDE'], { confidenceInterval: false, standardError: true, nonResponse: false });
        else if (test === 'slow1')
            setTest(stepIndex, [2017], [5], ['R_AGE65YR', 'R_INCOME', 'R_VETERAN3', 'R_AGEG5YR'], { confidenceInterval: false, standardError: true, nonResponse: false }); //Tested for 3.1
        else if (test === 'slow2')
            setTest(stepIndex, [2017], [5], ['R_AGE65YR', 'R_INCOME', 'R_AGEG5YR'], { confidenceInterval: true, standardError: true, nonResponse: true }); //Tested for 3.1
        else if (test === 'slow3')
            //setTest(stepIndex, [2015, 2016, 2017, 2018, 2019], [1, 2, 4, 5, 6, 8, 9, 10, 11, 12], ['R_MENT14D', 'location', 'R_AGEG5YR', 'year'],
            setTest(stepIndex, [2015, 2016], [1, 2], ['R_MENT14D', 'location', 'R_AGEG5YR', 'year'],
                { confidenceInterval: true, standardError: true, nonResponse: true }); //Tested for 3.1
        else if (test === 'noCi2')
            setTest(stepIndex, [2017], [2], ['RC_DROCDY3_', 'R_AGE65YR'], { confidenceInterval: true, standardError: true, nonResponse: true, weightedN: true }); //Tested for 3.1

        // [2015 - 2019]
        // AL, AK, AZ, AR, CA, CO, CT, DE, DC, FL
        // 'R_MENT14D', 'Location', 'R_AGEG5YR', 'Year'



        else if (test === 'noCi')
            setTest(stepIndex, [2014, 2015, 2016], [1, 78], ['location', 'R_FLUSHOT6', 'RC_AVEDRNK2', 'year'],
                { compareYears: true, compareLocations: true, confidenceInterval: true, standardError: true, nonResponse: true }); //Tested for 3.1
        //setTest(stepIndex, [2017], [2], ['RC_DROCDY3_', 'R_AGE65YR', 'R_BLIND', 'R_VETERAN3'], { confidenceInterval: true, standardError: true, nonResponse: true}); //Tested for 3.1
        else if (test === 'bothYearAndLocationSelected') {
            setTest(stepIndex, [2013, 2014, 2015], [1, 5], ['year', 'location'], { compareYears: true, compareLocations: true }); //Tested for 3.1
        }
        else if (test === 'noDataNotRight')
            setTest(stepIndex, [2015, 2016, 2017], [78, 66, 56], ['R_FLUSHOT6', 'RC_AVEDRNK2', 'year', 'location'], { compareYears: true, compareLocations: true }); //Tested for 3.1
        else if (test === 'funnyStyling')
            setTest(stepIndex, [2004], [1], ['R_SMOKER2', 'RC_ALCDAY3']);
        else if (test === 'error001')
            setTest(stepIndex, [2010], [1], ['R_QLREST2', 'R_RFBING4']);
        else if (test === 'error002')
            setTest(stepIndex, [2015], [1], ['R_FLUSHOT6', 'R_HCVU651', 'R_FLU6SHOT65', 'R_PA150R2']);
        else if (test === 'error003')
            setTest(stepIndex, [2014], [0], ['R_RFBLDS3', 'RC_AVEDRNK2']);
        else if (test === 'error004')
            setTest(stepIndex, [2008, 2009], [0], ['R_PERSDOC2', 'R_RFDRMN', 'R_AIDSTST']);
        else if (test === 'error005')
            setTest(stepIndex, [2004], [1], ['R_HADPAP2', 'R_RFBING4']);
            
        else if (test === 'rseOver_3')
            setTest(stepIndex, [2016], [1], ['R_MRACE1', 'R_VETERAN3']);
        else if (test === 'seOver_3')
            setTest(stepIndex, [2016], [1], ['R_INCOME', 'R_VETERAN3']);
        else if (test === 'missingData1')
            setTest(stepIndex, [2006, 2007], [66], ['R_ASTHMA', 'RN_AVEDRNK2']);
        else if (test === 'missingData2')
            setTest(stepIndex, [2014, 2016], [78], ['R_RFBLDS3', 'year', 'RC_AVEDRNK2'], { compareYears: true }); //Tested for 3.1
        else if (test === 'missingData3')
            setTest(stepIndex, [2014, 2015, 2016], [1, 78], ['location', 'R_FLUSHOT6', 'RC_AVEDRNK2', 'year'],
                { compareYears: true, compareLocations: true }); //Tested for 3.1
        else if (test === 'missingData4')
            setTest(stepIndex, [2014], [1, 2, 78], ['location', 'R_RFBLDS3', 'RC_AVEDRNK2'], { compareLocations: true }); //Tested for 3.1
        else if (test === 'missingData5')
            setTest(stepIndex, [2014], [1, 78], ['R_RFBLDS3', 'RC_AVEDRNK2', 'location', 'RC_DROCDY3_'], { compareLocations: true }); //Tested for 3.1
        else if (test === 'missingData6')
            setTest(stepIndex, [2014, 2015, 2016], [1, 78], ['R_FLUSHOT6', 'location', 'year'], { compareYears: true, compareLocations: true }); //Tested for 3.1
        else if (test === 'missingData2RowOnly')
            setTest(stepIndex, [2014, 2016], [78], ['year'], { compareYears: true }); //Tested for 3.1
        else if (test === 'notMissingData2')
            setTest(stepIndex, [2014], [1], ['R_RFBLDS3', 'RC_AVEDRNK2']); //Tested for 3.1
        else if (test === 'testVi10')
            setTest(stepIndex, [2014, 2016], [78], ['year']);
        else if (test === 'testVi11')
            setTest(stepIndex, [2014, 2016], [78], ['R_FLUSHOT6', 'R_EXERANY']);
        else if (test === 'testVi12')
            setTest(stepIndex, [2014, 2016], [78], ['R_RFBLDS3', 'year']);
        else if (test === 'testVi13')
            setTest(stepIndex, [2014, 2016], [78], ['R_RFBLDS3', 'RN_DRNKDRI2', 'year']);
        else if (test === 'testVi14')
            setTest(stepIndex, [2014, 2016], [78], ['R_RFBLDS3', 'year', 'RN_DRNKDRI2']);
        else if (test === 'testVi141')
            setTest(stepIndex, [2014, 2016], [78], ['year', 'R_RFBLDS3', 'RN_DRNKDRI2']);
        else if (test === 'testVi21')
            setTest(stepIndex, [2014, 2016], [1, 78], ['R_RFBLDS3', 'RN_DRNKDRI2']);
        else if (test === 'testVi211')
            setTest(stepIndex, [2014], [0], ['R_RFBLDS3', 'RN_DRNKDRI2']);
        else if (test === 'testVi22')
            setTest(stepIndex, [2014, 2016], [1, 78], ['R_RFBLDS3', 'year', 'RN_DRNKDRI2']);
        else if (test === 'testVi23')
            setTest(stepIndex, [2014, 2016], [1, 78], ['R_RFBLDS3', 'RN_DRNKDRI2', 'year']);
        else if (test === 'testVi32')
            setTest(stepIndex, [2014, 2016], [1, 78], ['R_RFBLDS3', 'location', 'RN_DRNKDRI2']);
        else if (test === 'testVi33')
            setTest(stepIndex, [2014, 2016], [1, 78], ['R_RFBLDS3', 'RN_DRNKDRI2', 'location']);
        else if (test === 'statistics1') {
            setTest(stepIndex, [2007], [1, 2, 3], ['R_FLU3SHOT65', 'R_AIDSTST']);
            setTest(stepIndex, [2007], [1, 2, 3], ['R_FLU3SHOT65']);
        } else if (test === 'statistics2')
            setTest(stepIndex, [2007], [1, 2, 3], ['R_AIDSTST']);
        else if (test === 'rowOnly')
            setTest(stepIndex, [2012], [1], ['R_RFSEAT3']);
        else if (test === 'test8') {
            commonTestHelper.setYearAs(stepIndex, 2014);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex); //Possibly change this to 2 (Alaska)
            setVariables(stepIndex, 'R_RFBLDS3', 'RN_DRNKDRI2', null, null, 2014);
            //setVariables(stepIndex, 'R_RFBLDS3', 'RN_DRNKDRI2', 'R_CASTHMA1', 'RC_ALC5DAY30', 2014);
            current.modelHelper.setAllStatistics();
        }
        else if (test === 'smallColsAndRows') {
            commonTestHelper.setYearAs(stepIndex, 2015);
            commonTestHelper.setLocationAsCombineByIndex(stepIndex, 1, 3);
            setVariables(stepIndex, 'R_RFHLTH', 'RC_MENTHLTH', null, null, 2015);
            current.modelHelper.setDefaultStatistics();
        }
        else if (test === 'test7') { // 8 seconds
            commonTestHelper.setYearAsCompare(stepIndex, [2012, 2014, 2016]);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            setVariables(stepIndex, 'R_QLACTLM2', 'R_ALTETH2', 'year', 'R_RFBMI5', 2014);
            current.modelHelper.setAllStatistics();
        }
        else if (test === 'test6') { // 8 seconds
            commonTestHelper.setYearAsCompare(stepIndex, [2012, 2014, 2016]);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            setVariables(stepIndex, 'RC_WTKG3', 'year', 'RN_DRNKDRI2', 'R_CASTHMA1', 2014);
            current.modelHelper.setAllStatistics();
        }
        else if (test === 'test2') { // 8 seconds
            commonTestHelper.setYearAsCompare(stepIndex, [2014, 2016]);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 3);
            setVariables(stepIndex, 'location', 'R_ADDEPEV2', 'year', 'R_RFBLDS3', 2014);
            current.modelHelper.setAllStatistics();
        }
        else if (test === 'test5') { // 8 seconds
            commonTestHelper.setYearAs(stepIndex, 2014);
            commonTestHelper.setLocationAsCombineByIndex(stepIndex, 0, 54);
            setVariables(stepIndex, 'R_RFBLDS3', 'RN_DRNKDRI2', null, null, 2014);
            current.modelHelper.setAllStatistics();
        }
        else if (test === 'justYears') {
            commonTestHelper.setYearAsCombine(stepIndex, [2013, 2014, 2015]);
        }
        else if (test === 'test4') { // 17 seconds
            commonTestHelper.setYearAsCompare(stepIndex, [2011, 2012, 2013, 2014, 2015, 2016]);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 3);
            setVariables(stepIndex, 'location', 'year', null, null, 2014);
            current.modelHelper.setAllStatistics();
        }
        else if (test === 'test3') {
            commonTestHelper.setYearAs(stepIndex, 2012);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            setVariables(stepIndex, 'R_RFSEAT3', 'RC_DRNK3GE5', null, null, 2012);
            current.modelHelper.setAllStatistics();
        }
        else if (test === 'manyControls') {
            commonTestHelper.setYearAs(stepIndex, 2006);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex); //Possibly change this to 2 (Alaska)
            setVariables(stepIndex, 'R_AIDSTST', 'R_BLDSTOOL', 'RC_FALLINJ2', 'R_ASTHNOW', 2006);
            current.modelHelper.setAllStatistics();
        }
        //TO DO: RC_FALLINJ2 is an invalid variable for CT.  Need to replace this in the test cases
        else if (test === 'hugeNumberOfControls') {
            commonTestHelper.setYearAs(stepIndex, 2006);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex); //Possibly change this to 2 (Alaska)
            setVariables(stepIndex, 'R_AIDSTST', 'R_BLDSTOOL', 'R_AGEG5YR', null, 2006);
            current.modelHelper.setAllStatistics();
        }
        else if (test === 'hugeNumberOfRowsAndColumns') {
            commonTestHelper.setYearAs(stepIndex, 2006);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex); //Possibly change this to 2 (Alaska)
            setVariables(stepIndex, 'R_AGEG5YR', 'RC_FALLINJ2', null, null, 2006);
            current.modelHelper.setAllStatistics();
        }
        else if (test === 'hugeNumberOfRowsAndColumnsWithControls') {
            commonTestHelper.setYearAs(stepIndex, 2006);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex); //Possibly change this to 2 (Alaska)
            setVariables(stepIndex, 'R_AGEG5YR', 'RC_FALLINJ2', 'R_ALTETH2', null, 2006);
            current.modelHelper.setAllStatistics();
        }
        else if (test === 'wideCol12') {
            commonTestHelper.setYearAs(stepIndex, 2014);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex); //Possibly change this to 2 (Alaska)
            setVariables(stepIndex, 'R_RFBLDS3', 'RN_DRNKDRI2', 'R_CASTHMA1', 'RC_ALC5DAY30', 2014);
            //current.modelHelper.setAllStatistics();
        }
        else if (test === 'longCtlLevelNames')
            setTest(stepIndex, [2012], [1], ['R_RFSEAT3', 'R_RFBLDS2', 'R_EDUCA', 'R_HOWLONG'],
                { confidenceInterval: true, standardError: true, nonResponse: true, weightedN: true });
        else if (test === 'shortCtlLevelNames') {
            commonTestHelper.setYearAs(stepIndex, 2012);
            commonTestHelper.setLocationAsCombineByIndex(stepIndex, 1, 3);
            setVariables(stepIndex, 'R_RFSEAT3', 'R_RFBLDS2', 'R_HAVARTH3', 'R_HADPAP2', 2012);
            current.modelHelper.setDefaultStatistics();
        }
        else if (test === 'mixedLengthCtlLevelNames') {
            commonTestHelper.setYearAs(stepIndex, 2012);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            setVariables(stepIndex, 'R_RFSEAT3', 'R_RFBLDS2', 'R_HAVARTH3', 'R_CNRACE', 2012);
            current.modelHelper.setDefaultStatistics();
        }
        else if (test === 'missingAndLowSample') {
            commonTestHelper.setYearAs(stepIndex, 2012);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            setVariables(stepIndex, 'R_PCPSADI1', 'R_CHLDCNT', 'R_FPHYSHLTH', null, 2012);
            current.modelHelper.setAllStatistics();
            //current.modelHelper.setMinimalStatistics();
        }
        else if (test === 'single') {
            commonTestHelper.setYearAs(stepIndex, 2012);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            setVariables(stepIndex, 'R_RFSEAT3', 'R_RFBLDS2', null, null, 2012);
            current.modelHelper.setAllStatistics();
        }
        else if (test === 'combineYears') {
            commonTestHelper.setYearAsCombine(stepIndex, [2013, 2014, 2015]);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 5);
            setVariables(stepIndex, 'R_RFSEAT3', 'year', null, null, 2013);
        }
        else if (test === 'combineYears2') {
            commonTestHelper.setYearAsCombine(stepIndex, [2006, 2016]);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            setVariables(stepIndex, 'R_PNEUVAC', 'R_RFSEAT3', null, null, 2006);
            current.modelHelper.setAllStatistics();
        }
        else if (test === 'justYearsAndLocations') {
            commonTestHelper.setYearAs(stepIndex, 2014);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex);
        }
        else if (test === 'largerResults') {
            commonTestHelper.setYearAs(stepIndex, 2014);
            commonTestHelper.setLocationAsCombineByIndex(stepIndex, 1, 2);
            setVariables(stepIndex, 'R_EMPLOY1', 'R_MARITAL', null, null, 2014);
        }
        else if (test === 'compareYears') {
            commonTestHelper.setYearAsCompare(stepIndex, [2013, 2015]);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 5);
            setVariables(stepIndex, 'R_RFSEAT3', 'year', 'RC_MENTHLTH', null, 2014);
        }
        else if (test === 'compareLocations') {
            commonTestHelper.setYearAs(stepIndex, 2012);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 5);
            setVariables(stepIndex, 'R_RFSEAT3', 'location', null, null, 2012);
        }
        else if (test === 'neitherYearOrLocationSelected') {
            commonTestHelper.setYearAsCompare(stepIndex, [2013, 2014, 2015]);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 5);
            setVariables(stepIndex, 'R_RFSEAT3', 'R_RFBLDS2', null, null, 2013);
        }
        else if (test === 'yearAlreadySelectedButNotLocation') {
            commonTestHelper.setYearAsCompare(stepIndex, [2012, 2014]);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 5);
            setVariables(stepIndex, 'year', 'R_RFBLDS2', null, null, 2014);
        } else if (test === 'justCompareYears') {
            commonTestHelper.setYearAsCompare(stepIndex, [2013, 2014, 2015]);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            setVariables(stepIndex, 'year', 'R_RFBLDS2', null, null, 2013);
        }
        else if (test === 'compareYearAndLocation') {
            commonTestHelper.setYearAsCompare(stepIndex, [2012, 2014]);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 5);
            setVariables(stepIndex, 'R_RFBLDS2', 'year', 'R_RFSEAT3', 'location', 2014);
        }
        else if (test === 'rowOnly') {
            commonTestHelper.setYearAs(stepIndex, 2012);
            commonTestHelper.setLocationAsSingleByIndex(stepIndex);
            setVariables(stepIndex, 'R_RFSEAT3', null, null, null, 2012);
            current.modelHelper.setDefaultStatistics();
        }
        else if (test === 'largeYearAndLocation') {
            commonTestHelper.setYearAsCompare(stepIndex, [2013, 2014]);
            commonTestHelper.setLocationAsCompareByIndex(stepIndex, 1, 5);
            setVariables(stepIndex, 'year', 'location', null, null, 2014);
        }
        console.log('Running test: ', test, current.selectionModel)
    },
    setControlAsNotSelected: function (stepIndex) {
        if (stepIndex >= current.navigation.stepIndex.controlvariables) {
            current.selectionModel.v.control1 = VariableSelection.newNotIncluded();
            current.selectionModel.v.control2 = VariableSelection.newNotIncluded();
        }
    },
    setTest: function (stepIndex, years, locations, variables) {
        setTest(stepIndex, years, locations, variables);
    }
}

function setVariable(variableType, variables, index, years) {

    var variableName = variables && variables.length > index ? variables[index] : null;

    const variableSelection = commonTestHelper.createVariableSelection(variableName, years[0]);
    console.log('setVariable', variableName, years[0], variableSelection);
    current.selectionModel.v[variableType] = variableSelection;
    // store.dispatch('selModel/setVariable', {
    //     variableType,
    //     variableSelection
    // });
    return true;
}


function setTest(stepIndex, years, locations, variables, options) {
    let compareYears = options && options.compareYears;
    let compareLocations = options && options.compareLocations;

    commonTestHelper.smartSetYears(stepIndex, years, compareYears);

    if (setTestUpTo() === 'years')
        return;

    commonTestHelper.setLocations(stepIndex, locations, years, compareLocations)
    if (setTestUpTo() === 'locations')
        return;

    if (stepIndex < current.navigation.stepIndex.rowvariable)
        return;

    setVariable('row', variables, 0, years)
    if (setTestUpTo() === 'row')
        return;
    if (stepIndex < current.navigation.stepIndex.columnvariable)
        return;
    setVariable('column', variables, 1, years)
    if (setTestUpTo() === 'column')
        return;

    if (stepIndex < current.navigation.stepIndex.controlvariables)
        return;
    setVariable('control1', variables, 2, years)
    if (setTestUpTo() === 'control1')
        return;

    setVariable('control2', variables, 3, years)
    if (setTestUpTo() === 'control2')
        return;

    //console.log('setStatistics 1', stepIndex, current.navigation.stepIndex.statistics);
    if (stepIndex < current.navigation.stepIndex.statistics)
        return;
    //console.log('setStatistics 2');
    current.modelHelper.setAllStatistics(options);
    // current.selectionModel.selectedStatistics.confidenceInterval = false;
    // current.selectionModel.selectedStatistics.standardError = false;
    //current.selectionModel.selectedStatistics.nonResponse = false;

}

function setVariables(stepIndex, row, column, control1, control2, year) {
    //console.log('setVariables 1', stepIndex, column, year)
    if (stepIndex < current.navigation.stepIndex.rowvariable)
        return;
    current.selectionModel.v.row = commonTestHelper.createVariableSelection(row, year);

    if (stepIndex < current.navigation.stepIndex.columnvariable)
        return;
    console.log('setVariables', column, year)

    current.selectionModel.v.column = commonTestHelper.createVariableSelection(column, year);

    if (stepIndex < current.navigation.stepIndex.controlvariables)
        return;
    current.selectionModel.v.control1 = commonTestHelper.createVariableSelection(control1, year);
    current.selectionModel.v.control2 = commonTestHelper.createVariableSelection(control2, year);
}
